export default __webpack_public_path__ + "static/media/Maison Neue Book.a494a4d3.ttf";